import { ArticleResult } from "interface/article"

import {
  Dialog
} from "@mui/material"

import { ArticlePreview } from '../../preview'

type ArticlePreviewDialogProps = {
  articleList?: ArticleResult[]
  article?: ArticleResult
  articleId?: number
  targetSisetuCode?: string
  targetKojinCode?: string
  targetAuthorId?: number
  onKojinOpen?: (kojinCode: string | null) => void
  onAuthorOpen?: (authorId: number | null) => void
  onClose: () => void
}
export const ArticlePreviewDialog = ({
  articleList,
  article,
  articleId,
  targetSisetuCode,
  targetKojinCode,
  targetAuthorId,
  onKojinOpen: onKojinOpenReply,
  onAuthorOpen: onAuthorOpenReply,
  onClose
}: ArticlePreviewDialogProps) => {
  return (
    <Dialog
      open
      fullWidth
      maxWidth='md'
      onClose={() => onClose()}
    >
      <ArticlePreview
        articleList={articleList}
        article={article}
        articleId={articleId}
        targetSisetuCode={targetSisetuCode}
        targetKojinCode={targetKojinCode}
        targetAuthorId={targetAuthorId}
        onKojinOpenReply={onKojinOpenReply}
        onAuthorOpenReply={onAuthorOpenReply}
        onClose={onClose}
        sx={{ height: '90vh' }}
      />
    </Dialog>
  );
}
